import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { ICompany } from 'src/app/interface/company';
import { environment } from 'src/environments/environment';
import { IResponse } from 'src/app/interface/response';
import { IUser } from 'src/app/interface/user';

@Injectable({
	providedIn: 'root',
})
export class CompanyService {

	private changeSubject: Subject<number>;

	constructor(private httpClient: HttpClient) {
		this.changeSubject = new Subject<number>();
	}

	public index(): Observable<IIndexResponse> {
		return this.httpClient.get<IIndexResponse>(
			environment.apiUrl + '/company/index'
		);
	}

	public current(companyId: number): Observable<ICurrentResponse> {
		return this.httpClient.post<ICurrentResponse>(
			environment.apiUrl + '/company/current',
			{ company_id: companyId }
		);
	}

	public show(): Observable<IShowResponse> {
		return this.httpClient.get<IShowResponse>(
			environment.apiUrl + '/{current_company_id}/company/show'
		);
	}

	public changeListener() {
		return this.changeSubject.asObservable();
	}

	public change(companyId: number): void {
		this.changeSubject.next(companyId);
	}
}

interface IIndexResponse {
	companies: Array<ICompany>;
}

interface IShowResponse {
	company: ICompany;
}

interface ICurrentResponse extends IResponse {
	user: IUser;
}
